import { useContext, useCallback } from 'react';
import { notificationApi } from '@bingads-webui-react/notification-center';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const FLOATING_BANNER_ID = 'floatingBannerId';
const DEFAULT_ERROR = _TL_('An unidentified error has occurred. Please try again later.');
const ERROR_MAPPING = {};

export function useFloatingBannerApi(errorMapping = ERROR_MAPPING) {
  const i18n = useContext(I18nContext);

  const showWarning = useCallback((error) => {
    const errorCode = error && (error.Code || error.Error);
    const errorMessage = errorMapping[errorCode] || DEFAULT_ERROR;
    notificationApi.showWarning(i18n.getString(errorMessage));
  }, [errorMapping, i18n]);

  const showInfo = useCallback((error) => {
    const errorCode = error && (error.Code || error.Error);
    const errorMessage = errorMapping[errorCode] || DEFAULT_ERROR;
    notificationApi.showInfo(i18n.getString(errorMessage));
  }, [errorMapping, i18n]);

  const showWarningMessage = useCallback((warningMsg, obj = {}) => {
    notificationApi.showWarning(i18n.getString(warningMsg, obj));
  }, [i18n]);

  const showInfoMessage = useCallback((infoMsg, obj = {}) => {
    notificationApi.showInfo(i18n.getString(infoMsg, obj));
  }, [i18n]);

  const showCustomizedWarning = useCallback((warningObj) => {
    notificationApi.showWarning(warningObj);
  }, []);

  const showCustomizedInfo = useCallback((infoObj) => {
    notificationApi.showInfo(infoObj);
  }, []);

  const dismissFloatingBanner = useCallback((id) => {
    notificationApi.dismiss(id || FLOATING_BANNER_ID);
  }, []);

  return {
    showWarning,
    showInfo,
    showWarningMessage,
    showInfoMessage,
    showCustomizedWarning,
    showCustomizedInfo,
    dismissFloatingBanner,
  };
}
